const $$splitComponentImporter = () => import('/src/src/routes/(compatibility)/groups.$groupId.news.$type.$postId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
/**
 * Redirect legacy news routes to new post routes (on group) for backward compatibility, including:
 * - /groups/:group_id/news/messages/:item_id
 * - /groups/:group_id/news/news_links/:item_id
 * - /groups/:group_id/news/social_links/:item_id
 *
 * @deprecated
 */
export const Route = createFileRoute("/(compatibility)/groups/$groupId/news/$type/$postId")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});